module.exports = __webpack_public_path__ + "static/media/2.668f5b96.jpg";